import { useQuery, useQueryClient } from 'react-query';
import { DEFAULT_READING_LIST } from '../../pages/MyContent/ArticlesTab/ArticlesTab.constants';
import { ReadingListDto } from '../../services/dtos/readingList/readingList.dto';
import { createReadingList } from '../../services/readingList/readingList.service';
import { queryKeys } from '../queryKeyFactory';
import useFetchReadingLists from './useFetchReadingLists';

interface UseDefaultReadingListOptions {
  keepPreviousData?: boolean;
  readingListName?: string;
  enabled?: boolean;
}

interface UseDefaultReadingListResult {
  data: ReadingListDto | undefined;
  isError: boolean;
  isLoading: boolean;
  isFetching: boolean;
}

export default ({
  keepPreviousData = true,
  readingListName = DEFAULT_READING_LIST,
  enabled = true,
}: UseDefaultReadingListOptions = {}): UseDefaultReadingListResult => {
  const queryClient = useQueryClient();
  const { data, isLoading, isFetching, isError } = useFetchReadingLists();

  const query = useQuery<ReadingListDto | undefined, Error>(
    queryKeys.fetchReadingLists.defaultReadingList(readingListName, data),
    async () => {
      const hasReadingLists = !!data?.length;
      const readingLists = hasReadingLists ? data : [await createReadingList(DEFAULT_READING_LIST)];

      if (!hasReadingLists) {
        queryClient.setQueryData(queryKeys.fetchReadingLists.all, readingLists);
      }

      return readingLists.find((readingList) => readingList.name === readingListName);
    },
    { enabled: enabled && !isLoading && data !== undefined, keepPreviousData }
  );

  return {
    data: query.data,
    isLoading: query.isLoading || isLoading,
    isFetching: query.isFetching || isFetching,
    isError: query.isError || isError,
  };
};
